import React from 'react';
import { Box, Body } from '@edreamsodigeo/prisma-design-system';
const GreyInfoMessage = ({
  text
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "neutral.30",
    borderRadius: "regular",
    p: "base"
  }, /*#__PURE__*/React.createElement(Body, {
    type: "base",
    weight: "medium",
    color: "neutral.80"
  }, text));
};
export default GreyInfoMessage;